import inView from 'in-view'

function statNumbers() {
    inView('.js-stat-number')
        .on('enter', (el) => {
            !el.classList.contains('on-screen') && el.classList.add('on-screen');
        })
    /* .on('exit', (el) => {
        el.classList.remove('on-screen');
    }) */
}

function appearOnScreen() {
    inView('.js-appear-on-screen')
        .on('enter', (el) => {
            !el.classList.contains('on-screen') && el.classList.add('on-screen');
        })
}

function appearOnScreenContainer() {
    inView('.js-appear-on-screen-container')
        .on('enter', (el) => {
            !el.classList.contains('on-screen') && el.classList.add('on-screen');
        })
}

function appearFromSide() {
    inView('.js-slide-in-l')
        .on('enter', (el) => {
            !el.classList.contains('on-screen') && el.classList.add('on-screen');
        })

    inView('.js-slide-in-r')
        .on('enter', (el) => {
            !el.classList.contains('on-screen') && el.classList.add('on-screen');
        })
}

export { statNumbers, appearOnScreen, appearOnScreenContainer, appearFromSide }